import type { BattleView, PlayCardCommand } from '../../engine/types';
import type { BotDefinition, BotPolicy, BotPolicyContext } from './types';

export class BotController {
  private readonly policy: BotPolicy;

  constructor(readonly definition: BotDefinition, private readonly context: BotPolicyContext) {
    this.policy = definition.createPolicy(context);
  }

  decide(view: BattleView): PlayCardCommand | null {
    const command = this.policy.decide(view);
    if (!command) return null;
    const legalShape = command.playerId === this.context.playerId
      && command.tick === view.tick
      && command.sequence === view.player.nextSequence
      && view.tick >= view.player.nextCardReadyTick
      && view.player.hand.includes(command.cardId)
      && this.context.content.cards.has(command.cardId)
      && Number.isFinite(command.position.x)
      && Number.isFinite(command.position.y);
    if (legalShape) return command;
    this.context.journal.record({
      tick: view.tick,
      phase: 'bot',
      source: 'bot-controller',
      level: 'error',
      code: 'BOT_ILLEGAL_ACTION',
      cardIds: [command.cardId],
      payload: {
        botId: this.definition.id,
        botVersion: this.definition.version,
        policyId: this.policy.id,
        policyVersion: this.policy.version,
        command,
      },
    });
    return null;
  }
}
